export default 
`

       __    ____ __  ______     
      ( /  /( /( /  )(  /        
       /--/  /  /--<   /--       
      /  /__/_ /   \_(/____/     
                           
        _,   __   ______  _,  ,
       / |  ( /  (  /    ( |,' 
      /--|   /     /--     +   
    _/   |_(/___/(/____/_,'|__ 
                           
`